export const formTemplateStatusEnum = {
    DRAFT: 1,
    PUBLISHED: 5,
    INACTIVE: 15,
};

export const formResponseStatusEnum = {
    DRAFT: 1,
    SUBMITTED: 10,
};

export const questionTypeEnum = {
    TEXT_SHORT: 1,
    TEXT_LONG: 2,
    SINGLE_CHOICE: 3,
    MULTIPLE_CHOICE: 4,
};
